export function maxValue(val,max_val=100) {
  return (val > max_val) ? max_val : val;
}
